import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am{" "}
            <span className="blue">Cleomark Ian Calitisin </span>
            from <span className="blue"> Tabaco City, Albay Philippines.</span>
            <br />
            <br />
            I'm currently working as a <b>Software Engineer I</b> at <b>Kyocera Document Solutions</b> in Cebu City, Cebu,
            where I focus on building reliable and maintainable software solutions.
            <br />
            While my primary background is in software engineering, I also have a strong interest in cybersecurity 
            and am actively exploring entry-level opportunities in that space where my skills are applicable. 
            I’m particularly interested in areas where secure design and software development intersect.
            <br />
            I earned a <b>Bachelor of Science in Computer Science</b> from <b>Bicol University College of Science</b> , graduating <i>Cum Laude.</i>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Working out
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching movies and TV shows
            </li>
            <li className="about-activity">
              <ImPointRight /> Trying new things and learning continuously
            </li>
          </ul>

          <p style={{ color: "#4585f9" }}>
            "First, solve the problem. Then, write the code."{" "}
          </p>
          <footer className="blockquote-footer">John Johnson</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
